import { toast } from "react-hot-toast";
import { trackEvent } from "./tracker";

let installed = false;

const messageToString = (msg: unknown): string => {
  if (typeof msg === "string") return msg;
  if (msg && typeof msg === "object" && "toString" in msg) {
    try {
      return String(msg);
    } catch {
      return "[non-serializable]";
    }
  }
  return "[non-string]";
};

export const installToastTracking = () => {
  if (installed) return;
  installed = true;

  const original = toast.error.bind(toast);
  (toast as unknown as { error: typeof toast.error }).error = ((
    message: Parameters<typeof toast.error>[0],
    opts?: Parameters<typeof toast.error>[1]
  ) => {
    try {
      trackEvent("error_shown", {
        payload: {
          message: messageToString(message),
          source: "toast",
        },
      });
    } catch {
      // analytics must never block UX
    }
    return original(message, opts);
  }) as typeof toast.error;
};
